<template lang="pug">
#aviso-selecionar-territorio(v-if="shouldShowAviso")
    el-alert(
        :title="$t('mensagens.laudos.avisoPadrao')"
        type="warning"
        show-icon
        close-text=""
        :closable="true"
    )
</template>

<script>
import TipoLaudo from '@/constants/TipoLaudo';

export default {
    name: 'AvisoSelecionarTerritorio',
    props: {
        tipoLaudo: {
            type: Number,
            required: true
        }
    },
    computed: {
        shouldShowAviso() {
            const laudosQueMostramAviso = [TipoLaudo.AVALIACAO_SOCIOAMBIENTAL, TipoLaudo.CARBONO, TipoLaudo.CONFORMIDADE, TipoLaudo.RENOVABIO];
            return laudosQueMostramAviso.includes(this.tipoLaudo);
        }
    }

};
</script>
    
<style lang="scss">
#aviso-selecionar-territorio {
    margin-bottom: 20px;
}
</style>
